import { createApiMutationHook, IApiMutationFunction } from "@sol/sdk/utils/api";

import { IAIChatMessage } from "./aiMessageSendMutation";

export type IAIMessageEditMutationParameters = {
    interactionUuid: string; // UUID of the exchange to edit
    message: string; // New edited message
};

export type IAIMessageEditMutationResult = IAIChatMessage;

export const aiMessageEditMutation: IApiMutationFunction<IAIMessageEditMutationParameters> = ({
    interactionUuid,
    message,
}) => {
    return {
        method: "POST",
        url: `/ai/edit/${interactionUuid}`,
        data: {
            message,
        },
    };
};

export const useAIMessageEditMutation = createApiMutationHook<
    IAIMessageEditMutationParameters,
    IAIMessageEditMutationResult
>(aiMessageEditMutation);
